<template>
  <section>
    <b-button
      v-if="isModal"
      size="is-small"
      class="login-trigger-button"
      style="border-radius: 6px"
      outlined
      @click="handleShowLogin()"
      >登录</b-button
    >
    <b-modal
      v-if="isModal"
      v-model="isComponentModalActive"
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-label="Example Modal"
      close-button-aria-label="Close"
      aria-modal
    >
      <div class="login-box">
        <div class="login-box-l"></div>
        <div class="login-box-r">
          <div class="login-tabs">
            <div
              class="tab-item"
              :class="{ active: loginType === 'account' }"
              @click="loginType = 'account'"
            >
              账号密码登录
            </div>
            <div
              class="tab-item"
              :class="{ active: loginType === 'phone' }"
              @click="loginType = 'phone'"
            >
              手机验证码登录
            </div>
          </div>
          <form
            style="width: 354px"
            method="POST"
            @submit.prevent="handleLogin"
          >
            <!-- 账号密码登录 -->
            <div v-if="loginType === 'account'">
              <b-field
                style="height: 90px"
                label="账号"
                :message="usernameMessage"
              >
                <b-input
                  v-model="loginForm.username"
                  type="username"
                  required
                  placeholder="请输入用户名或邮箱"
                  @blur="validateUsername"
                />
              </b-field>
              <b-field style="height: 90px" label="密码" :message="pwdMessage">
                <b-input
                  v-model="loginForm.password"
                  type="password"
                  password-reveal
                  required
                  placeholder="请输入密码"
                  @blur="validatePwd"
                />
              </b-field>
              <div>
                <b-field
                  style="height: 90px"
                  label="验证码"
                  :message="codeMessage"
                >
                  <b-input
                    v-model="loginForm.code"
                    type="code"
                    required
                    placeholder="请输入验证码"
                    @blur="validateCode"
                  />
                  <div
                    class="login-code"
                    style="
                      cursor: pointer;
                      margin-left: 5px;
                      height: 40px;
                      float: right;
                      background-color: #f0f1f5;
                    "
                  >
                    <img
                      style="
                        width: 100%;
                        height: 40px;
                        border: 1px solid rgba(0, 0, 0, 0.1);
                        border-radius: 2px;
                      "
                      :src="codeUrl"
                      alt="yzm"
                      @click="getCode"
                    />
                  </div>
                </b-field>
              </div>
            </div>
            <!-- 手机验证码登录 -->
            <div v-else>
              <b-field
                style="height: 90px"
                label="手机号"
                :message="phoneMessage"
              >
                <b-input
                  v-model="phoneForm.mobile"
                  type="tel"
                  required
                  placeholder="请输入手机号"
                  @blur="validatePhone"
                />
              </b-field>
              <b-field
                style="height: 90px"
                label="图形验证码"
                :message="phoneCodeMessage"
              >
                <div class="input-field">
                  <b-input
                    v-model="phoneForm.code"
                    type="code"
                    required
                    placeholder="请输入图形验证码"
                    @blur="validatePhoneCode"
                  />
                  <div
                    class="login-code"
                    style="
                      cursor: pointer;
                      margin-left: 5px;
                      height: 40px;
                      float: right;
                      background-color: #f0f1f5;
                    "
                  >
                    <img
                      style="
                        width: 100%;
                        height: 40px;
                        border: 1px solid rgba(0, 0, 0, 0.1);
                        border-radius: 2px;
                      "
                      :src="codeUrl"
                      alt="yzm"
                      @click="getCode"
                    />
                  </div>
                </div>
              </b-field>
              <b-field
                style="height: 90px"
                label="短信验证码"
                :message="smsCodeMessage"
              >
                <div class="input-field">
                  <b-input
                    v-model="phoneForm.smsCode"
                    type="text"
                    required
                    placeholder="请输入短信验证码"
                    @blur="validateSmsCode"
                  />
                  <span
                    class="send-code-btn"
                    :class="{ disabled: countdown > 0 }"
                    @click="sendSmsCode"
                  >
                    {{ countdown > 0 ? `${countdown}秒` : "发送验证码" }}
                  </span>
                </div>
              </b-field>
            </div>
            <div class="login-footer-btn">
              <b-button
                class="item-btn"
                label="取消"
                type="is-light"
                @click="isComponentModalActive = false"
              />
              <b-button
                class="item-btn"
                label="登录"
                type="is-primary"
                @click="handleLogin"
              />
            </div>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <a
                class="login-zc"
                :href="signupUrl"
                target="_blank"
                rel="noopener noreferrer"
                has-text-black
                >点击注册>></a
              >
              <a
                v-if="loginType === 'account'"
                class="login-zc"
                :href="forgetUrl"
                target="_blank"
                rel="noopener noreferrer"
                has-text-black
                >忘记密码?</a
              >
            </div>
          </form>
        </div>
      </div>
    </b-modal>
    <div class="login-box" v-else>
      <div class="login-box-l"></div>
      <div class="login-box-r">
        <div class="login-tabs">
          <div
            class="tab-item"
            :class="{ active: loginType === 'account' }"
            @click="loginType = 'account'"
          >
            账号密码登录
          </div>
          <div
            class="tab-item"
            :class="{ active: loginType === 'phone' }"
            @click="loginType = 'phone'"
          >
            手机验证码登录
          </div>
        </div>
        <form style="width: 354px" method="POST" @submit.prevent="handleLogin">
          <!-- 账号密码登录 -->
          <div v-if="loginType === 'account'">
            <b-field
              style="height: 90px"
              label="账号"
              :message="usernameMessage"
            >
              <b-input
                v-model="loginForm.username"
                type="username"
                required
                placeholder="请输入用户名或邮箱"
                @blur="validateUsername"
              />
            </b-field>
            <b-field style="height: 90px" label="密码" :message="pwdMessage">
              <b-input
                v-model="loginForm.password"
                type="password"
                password-reveal
                required
                placeholder="请输入密码"
                @blur="validatePwd"
              />
            </b-field>
            <div>
              <b-field
                style="height: 90px"
                label="验证码"
                :message="codeMessage"
              >
                <b-input
                  v-model="loginForm.code"
                  type="code"
                  required
                  placeholder="请输入验证码"
                  @blur="validateCode"
                />
                <div
                  class="login-code"
                  style="
                    cursor: pointer;
                    margin-left: 5px;
                    height: 40px;
                    float: right;
                    background-color: #f0f1f5;
                  "
                >
                  <img
                    style="
                      width: 100%;
                      height: 40px;
                      border: 1px solid rgba(0, 0, 0, 0.1);
                      border-radius: 2px;
                    "
                    :src="codeUrl"
                    alt="yzm"
                    @click="getCode"
                  />
                </div>
              </b-field>
            </div>
          </div>
          <!-- 手机验证码登录 -->
          <div v-else>
            <b-field
              style="height: 90px"
              label="手机号"
              :message="phoneMessage"
            >
              <b-input
                v-model="phoneForm.mobile"
                type="tel"
                required
                placeholder="请输入手机号"
                @blur="validatePhone"
              />
            </b-field>
            <b-field
              style="height: 90px"
              label="验证码"
              :message="smsCodeMessage"
            >
              <b-input
                v-model="phoneForm.smsCode"
                type="text"
                required
                placeholder="请输入短信验证码"
                @blur="validateSmsCode"
              />
              <span
                class="send-code-btn"
                :class="{ disabled: countdown > 0 }"
                @click="sendSmsCode"
              >
                {{ countdown > 0 ? `${countdown}秒` : "发送验证码" }}
              </span>
            </b-field>
            <div>
              <b-field
                style="height: 90px"
                label="验证码"
                :message="phoneCodeMessage"
              >
                <b-input
                  v-model="phoneForm.code"
                  type="code"
                  required
                  placeholder="请输入验证码"
                  @blur="validatePhoneCode"
                />
                <div
                  class="login-code"
                  style="
                    cursor: pointer;
                    margin-left: 5px;
                    height: 40px;
                    float: right;
                    background-color: #f0f1f5;
                  "
                >
                  <img
                    style="
                      width: 100%;
                      height: 40px;
                      border: 1px solid rgba(0, 0, 0, 0.1);
                      border-radius: 2px;
                    "
                    :src="codeUrl"
                    alt="yzm"
                    @click="getCode"
                  />
                </div>
              </b-field>
            </div>
          </div>
          <div class="login-footer-btn">
            <b-button
              class="item-btn"
              label="取消"
              type="is-light"
              @click="isComponentModalActive = false"
            />
            <b-button
              class="item-btn"
              label="登录"
              type="is-primary"
              @click="handleLogin"
            />
          </div>

          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <a
              class="login-zc"
              :href="signupUrl"
              target="_blank"
              rel="noopener noreferrer"
              has-text-black
              >点击注册>></a
            >
            <a
              v-if="loginType === 'account'"
              class="login-zc"
              :href="forgetUrl"
              target="_blank"
              rel="noopener noreferrer"
              has-text-black
              >忘记密码?</a
            >
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { getCodeImg, sendSmsCode } from "@/api/login";
export default {
  props: {
    isModal: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      signupUrl: process.env.VUE_APP_BBS_URL + "/user/signup",
      forgetUrl: process.env.VUE_APP_BBS_URL + "/user/forget",
      indefinteToast: "",
      codeUrl: "",
      isLoading: false,
      formValid: false,
      usernameMessage: "",
      usernameValid: false,
      pwdMessage: "",
      pwdValid: false,
      codeMessage: "",
      codeValid: false,
      phoneMessage: "",
      phoneValid: false,
      smsCodeMessage: "",
      smsCodeValid: false,
      phoneCodeMessage: "",
      phoneCodeValid: false,
      isComponentModalActive: false,
      loginType: "account",
      countdown: 0,
      loginForm: {
        username: undefined,
        password: undefined,
        rememberMe: false,
        code: undefined,
        uuid: "",
      },
      phoneForm: {
        mobile: undefined,
        smsCode: undefined,
        code: undefined,
        uuid: "",
      },
    };
  },
  created() {
    document.addEventListener(
      "csCustomLoginEvent",
      (event) => {
        this.isComponentModalActive = true;
        this.getCode();
      },
      {
        once: false,
      }
    );
  },
  methods: {
    handleShowLogin() {
      this.getCode();
      sessionStorage.setItem("attemptedURL", this.$route.fullPath);
      this.isComponentModalActive = true;
    },
    getCode() {
      getCodeImg().then((res) => {
        if (res !== undefined) {
          this.codeUrl = res.data;
          this.loginForm.uuid = res.id;
        }
      });
    },
    validateUsername() {
      if (!this.loginForm.username) {
        this.usernameValid = false;
        this.usernameMessage = "账号不能为空";
      } else {
        this.usernameValid = true;
        this.usernameMessage = "";
      }
    },
    validatePwd() {
      if (!this.loginForm.password) {
        this.pwdValid = false;
        this.pwdMessage = "密码不能为空";
      } else {
        this.pwdValid = true;
        this.pwdMessage = "";
      }
    },
    validateCode() {
      if (!this.loginForm.code) {
        this.codeValid = false;
        this.codeMessage = "验证码不能为空";
      } else {
        this.codeValid = true;
        this.codeMessage = "";
      }
    },
    validatePhone() {
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!this.phoneForm.mobile) {
        this.phoneValid = false;
        this.phoneMessage = "手机号不能为空";
      } else if (!phoneRegex.test(this.phoneForm.mobile)) {
        this.phoneValid = false;
        this.phoneMessage = "请输入正确的手机号";
      } else {
        this.phoneValid = true;
        this.phoneMessage = "";
      }
    },
    validateSmsCode() {
      if (!this.phoneForm.smsCode) {
        this.smsCodeValid = false;
        this.smsCodeMessage = "验证码不能为空";
      } else {
        this.smsCodeValid = true;
        this.smsCodeMessage = "";
      }
    },
    validatePhoneCode() {
      if (!this.phoneForm.code) {
        this.phoneCodeValid = false;
        this.phoneCodeMessage = "验证码不能为空";
      } else {
        this.phoneCodeValid = true;
        this.phoneCodeMessage = "";
      }
    },
    sendSmsCode() {
      if (this.countdown > 0) {
        return;
      }
      if (!this.phoneValid) {
        this.validatePhone();
        if (!this.phoneValid) {
          return;
        }
      }
      if (!this.phoneCodeValid) {
        this.validatePhoneCode();
        if (!this.phoneCodeValid) {
          return;
        }
      }
      const data = {
        mobile: this.phoneForm.mobile,
        uuid: this.loginForm.uuid,
        code: this.phoneForm.code,
      };
      sendSmsCode(data)
        .then(() => {
          this.countdown = 60;
          const timer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
              clearInterval(timer);
            }
          }, 1000);
          this.indefinteToast = this.$buefy.toast.open({
            duration: 2000,
            message: `验证码已发送到 ${this.phoneForm.mobile}`,
            type: "is-success",
          });
        })
        .catch(() => {
          this.getCode();
        });
    },
    handleLogin(e) {
      if (this.loginType === "account") {
        if (!this.pwdValid || !this.usernameValid || !this.codeValid) {
          this.indefinteToast = this.$buefy.toast.open({
            duration: 3000,
            message: `请检查输入的账号、密码和验证码`,
            type: "is-warning",
          });
          return;
        }
        this.isLoading = true;
        this.$store
          .dispatch("login", this.loginForm)
          .then((res) => {
            this.isComponentModalActive = false;
            console.log("login success");
            this.$emit("loginSuccess");
            const okEvent = new CustomEvent("csCustomLoginSuccessEvent", {
              detail: {}, // 自定义事件的详细信息
              bubbles: true, // 事件是否冒泡
              cancelable: true, // 事件是否可以被取消
            });
            document.dispatchEvent(okEvent);
          })
          .catch((err) => {
            this.isLoading = false;
            this.loginForm.code = "";
            this.getCode();
          });
      } else {
        if (!this.phoneValid || !this.smsCodeValid || !this.phoneCodeValid) {
          this.phoneForm.smsCode = "";
          this.phoneForm.code = "";
          this.getCode();
          this.indefinteToast = this.$buefy.toast.open({
            duration: 3000,
            message: `请检查输入的手机号和验证码`,
            type: "is-warning",
          });
          return;
        }
        this.isLoading = true;
        this.$store
          .dispatch("phoneLoginAction", this.phoneForm)
          .then((res) => {
            this.isComponentModalActive = false;
            console.log("phone login success");
            this.$emit("loginSuccess");
            const okEvent = new CustomEvent("csCustomLoginSuccessEvent", {
              detail: {},
              bubbles: true,
              cancelable: true,
            });
            document.dispatchEvent(okEvent);
          })
          .catch((err) => {
            this.isLoading = false;
            this.phoneForm.smsCode = "";
            this.phoneForm.code = "";
            this.getCode();
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-zc {
  outline: none;
  color: #57aecc;
  font-size: 14px;
}
.login-trigger-button {
  border-color: #57aecc;
  color: #57aecc;
  width: 75px;
  height: 35px;
  line-height: 45px;
  text-align: center;
  border-radius: 10px !important;
  font-size: 18px;
  font-weight: 500;
}
.login-trigger-button:hover {
  background-color: #57aecc;
  color: #fff;
}
.login-footer-btn {
  display: flex;
  justify-content: space-between;
  padding: 20px 0 10px;
  box-sizing: border-box;
  .item-btn {
    flex: 1;
    &:first-child {
      margin-right: 20px;
    }
  }
}
.login-box-r {
  margin: 0 auto;
  text-align: left;
  padding-top: 40px;
}
.login-box {
  width: 950px;
  height: 540px;
  background-color: #fff;
  display: flex;
  align-items: center;
  z-index: 1000;
  .login-box-l {
    width: 50%;
    height: 540px;
    background: url("../assets/login/login-bg.png") no-repeat center center;
    background-size: cover;
  }
}
.login-tabs {
  display: flex;
  margin-bottom: 30px;
  border-bottom: 2px solid #e0e0e0;

  .tab-item {
    padding: 10px 20px;
    cursor: pointer;
    font-size: 16px;
    color: #666;
    transition: all 0.3s;
    position: relative;

    &:hover {
      color: #57aecc;
    }

    &.active {
      color: #57aecc;
      font-weight: 500;

      &::after {
        content: "";
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: #57aecc;
      }
    }

    &:first-child {
      margin-right: 30px;
    }
  }
}
.login-btn {
  cursor: pointer;
  width: 60px;
  line-height: 26px;
  border-radius: 6px;
  border: 1px solid rgba(73, 168, 200, 1);
  font-size: 14px;
  font-weight: 500;
  color: rgba(87, 174, 204, 1);
  text-align: center;
}
.input-field {
  display: flex;
  align-items: center;
  gap: 6px;
  .control {
    flex: 1;
  }
  .send-code-btn {
    color: #57aecc;
    cursor: pointer;
    font-size: 14px;
    white-space: nowrap;
    user-select: none;

    &:hover:not(.disabled) {
      color: #4a96b3;
      text-decoration: underline;
    }

    &.disabled {
      color: #ccc;
      cursor: not-allowed;
    }
  }
}
.field :deep(.help) {
  color: hsl(348, 86%, 61%);
}
</style>
